import { createEffect, onCleanup, type Accessor } from 'solid-js';
import { subscribeBotEngineEvents, subscribeBotEngineStream } from '../services/botEngineEvents';

export type PaymentChangeKind = 'ledger' | 'schedule';

/**
 * Calls onChange for every payments change on the bot's event stream, and with kind null when the
 * stream reconnected or dropped events, since nothing replays what was missed.
 */
export function usePaymentChanges(botId: Accessor<string | null | undefined>, onChange: (kind: PaymentChangeKind | null, id: string | null) => void) {
    createEffect(() => {
        const id = botId();
        if (!id) return;
        const stopEvents = subscribeBotEngineEvents(id, (evt) => {
            if (evt.type === 'plugin_event' && evt.payload?.source === 'payments') onChange(evt.payload.kind ?? null, evt.payload.id ?? null);
        });
        let seenEpoch: number | null = null;
        const stopStream = subscribeBotEngineStream(id, (stream) => {
            if (seenEpoch !== null && stream.epoch !== seenEpoch) onChange(null, null);
            seenEpoch = stream.epoch;
        });
        onCleanup(() => { stopEvents(); stopStream(); });
    });
}
